// extracted by mini-css-extract-plugin
module.exports = {"container":"_8ZADfe4q9yWde1zW9Ze5i","header":"_3GO7m6XP30vuZMwN7NYi3k","content":"_2CYZEndnlXVuLQTSgVKe4c"};